/* Noirarchy Sightings (sections/noir-sightings.liquid; handoff 6.1.3 and 6.2, plan
   "Sightings"). Loaded with defer from the section, only when the section renders.

   Desktop (990px and wider): three cards in view. The track moves one card at a time
   through --noir-sightings-index (CSS transform, 600ms); the progress thumb follows the
   same index. Next from the last page goes to the first, previous from the first goes
   to the last page. Any arrow use stops autoplay for good (so does keyboard focus on
   an arrow). Autoplay runs every data-desktop-seconds only with more than three cards.

   Mobile: the track is a native scroll-snap strip. Autoplay scrolls to the next card
   every data-mobile-seconds and wraps to the start at the end. touchstart, pointerdown,
   wheel or a key on the strip stops it for good. The thin line under the strip follows
   the scroll position (--noir-sightings-progress, 0 to 1). The strip gets tabindex="0"
   on phones so keys can scroll it.

   Autoplay needs data-autoplay="true", never runs under prefers-reduced-motion (which
   also turns smooth scrolling off), pauses while the tab is hidden and while the
   section is off screen. Images load as the section nears the viewport, so cards that
   slide in later are ready. Cards are never aria-hidden: every card is real content.

   Theme editor: shopify:block:select brings that card into view and stops autoplay;
   sections are set up again on shopify:section:load and torn down on unload.
   API: Noir.sightings.init(scope), Noir.sightings.destroy(scope). */
(function () {
  'use strict';

  window.Noir = window.Noir || {};
  if (window.Noir.sightings) return;

  var ROOT = '[data-noir-sightings]';
  var VISIBLE = 3;
  var desktopQuery = window.matchMedia ? window.matchMedia('(min-width: 990px)') : null;
  var motionQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  function reduceMotion() {
    if (typeof window.Noir.reduceMotion === 'function') return window.Noir.reduceMotion();
    return !!(motionQuery && motionQuery.matches);
  }

  function isDesktop() {
    return !!(desktopQuery && desktopQuery.matches);
  }

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function seconds(root, name, fallback) {
    var value = parseFloat(root.getAttribute(name));
    if (!isFinite(value) || value <= 0) value = fallback;
    return Math.max(value, 2) * 1000;
  }

  function listen(query, fn, add) {
    if (!query) return;
    if (typeof query.addEventListener === 'function') {
      if (add) query.addEventListener('change', fn);
      else query.removeEventListener('change', fn);
    } else if (typeof query.addListener === 'function') {
      if (add) query.addListener(fn);
      else query.removeListener(fn);
    }
  }

  function Sightings(root) {
    var self = this;
    this.root = root;
    this.track = root.querySelector('[data-noir-sightings-track]');
    this.viewport = root.querySelector('[data-noir-sightings-viewport]');
    this.prevBtn = root.querySelector('[data-noir-sightings-prev]');
    this.nextBtn = root.querySelector('[data-noir-sightings-next]');
    this.controls = root.querySelector('[data-noir-sightings-controls]');
    this.items = this.track ? toArray(this.track.querySelectorAll('[data-noir-sightings-item]')) : [];
    this.count = this.items.length;
    this.index = 0;
    this.autoplay = root.getAttribute('data-autoplay') === 'true';
    this.desktopDelay = seconds(root, 'data-desktop-seconds', 4.5);
    this.mobileDelay = seconds(root, 'data-mobile-seconds', 4);
    this.stopped = false;
    this.timer = 0;
    this.frame = 0;
    this.inView = !('IntersectionObserver' in window);
    this.desktop = isDesktop();

    this.onClick = function (e) {
      var t = e.target && e.target.closest ? e.target.closest('[data-noir-sightings-prev], [data-noir-sightings-next]') : null;
      if (!t || !self.root.contains(t)) return;
      self.stop();
      self.go(self.index + (t.hasAttribute('data-noir-sightings-prev') ? -1 : 1));
    };

    /* Keyboard focus on an arrow counts as using it; a mouse press is handled by click. */
    this.onFocusIn = function (e) {
      var t = e.target;
      var keyboard = true;
      try {
        keyboard = t.matches(':focus-visible');
      } catch (err) {}
      if (keyboard) self.stop();
    };

    /* Phones: touch, drag, wheel or keys on the strip stop autoplay for good. */
    this.onInput = function () {
      if (!self.desktop) self.stop();
    };

    this.onScroll = function () {
      if (self.frame) return;
      self.frame = window.requestAnimationFrame(function () {
        self.frame = 0;
        self.progress();
      });
    };

    this.onVisibility = function () {
      if (document.hidden) self.pause();
      else self.play();
    };

    this.onMotion = function () {
      if (reduceMotion()) self.pause();
      else self.play();
    };

    this.onMode = function () {
      self.setMode();
    };

    if (!this.track || !this.count) return;

    root.addEventListener('click', this.onClick);
    if (this.controls) this.controls.addEventListener('focusin', this.onFocusIn);
    this.track.addEventListener('touchstart', this.onInput, { passive: true });
    this.track.addEventListener('pointerdown', this.onInput, { passive: true });
    this.track.addEventListener('wheel', this.onInput, { passive: true });
    this.track.addEventListener('keydown', this.onInput);
    this.track.addEventListener('scroll', this.onScroll, { passive: true });
    document.addEventListener('visibilitychange', this.onVisibility);
    listen(motionQuery, this.onMotion, true);
    listen(desktopQuery, this.onMode, true);
    if (!desktopQuery) window.addEventListener('resize', this.onMode);

    if ('ResizeObserver' in window) {
      this.resizer = new ResizeObserver(function () { self.progress(); });
      this.resizer.observe(this.track);
    }

    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          self.inView = entry.isIntersecting;
          if (self.inView) self.play();
          else self.pause();
        });
      });
      this.observer.observe(root);
      this.loader = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          self.loadImages();
          if (self.loader) self.loader.disconnect();
        });
      }, { rootMargin: '400px 0px' });
      this.loader.observe(root);
    } else {
      this.loadImages();
    }

    this.setMode(true);
  }

  /* Lazy images in cards that are clipped off to the side would only start loading
     as they slide in; load them all once the section is within 400px of the screen. */
  Sightings.prototype.loadImages = function () {
    if (this.loaded) return;
    this.loaded = true;
    toArray(this.track.querySelectorAll('img[loading="lazy"]')).forEach(function (img) {
      img.loading = 'eager';
    });
  };

  Sightings.prototype.setMode = function (first) {
    var desktop = isDesktop();
    if (!first && desktop === this.desktop) return;
    this.desktop = desktop;
    this.pause();
    if (desktop) {
      this.track.removeAttribute('tabindex');
      this.track.scrollLeft = 0;
      this.index = Math.min(this.index, this.maxIndex());
      this.render();
    } else {
      this.track.setAttribute('tabindex', '0');
      this.progress();
    }
    this.play();
  };

  Sightings.prototype.maxIndex = function () {
    return Math.max(0, this.count - VISIBLE);
  };

  Sightings.prototype.canAdvance = function () {
    if (this.desktop) return this.maxIndex() > 0;
    return this.count > 1 && this.scrollMax() > 2;
  };

  Sightings.prototype.canPlay = function () {
    return this.autoplay && !this.stopped && this.inView && !document.hidden && !reduceMotion() && this.canAdvance();
  };

  Sightings.prototype.play = function () {
    var self = this;
    if (this.timer || !this.canPlay()) return;
    this.timer = window.setInterval(function () {
      if (!self.canPlay()) {
        self.pause();
        return;
      }
      if (self.desktop) self.go(self.index + 1);
      else self.advance();
    }, this.desktop ? this.desktopDelay : this.mobileDelay);
  };

  Sightings.prototype.pause = function () {
    if (!this.timer) return;
    window.clearInterval(this.timer);
    this.timer = 0;
  };

  /* Manual input: autoplay ends for good. */
  Sightings.prototype.stop = function () {
    this.stopped = true;
    this.pause();
  };

  /* ---------- Desktop: one card per step, looping both ways ---------- */
  Sightings.prototype.go = function (i) {
    var max = this.maxIndex();
    if (!max) return;
    var index = i > max ? 0 : i < 0 ? max : i;
    if (index === this.index) return;
    this.index = index;
    this.render();
  };

  Sightings.prototype.render = function () {
    this.root.style.setProperty('--noir-sightings-index', String(this.index));
  };

  /* ---------- Mobile: native strip ---------- */
  Sightings.prototype.scrollMax = function () {
    return Math.max(this.track.scrollWidth - this.track.clientWidth, 0);
  };

  Sightings.prototype.offsetOf = function (i) {
    return this.items[i].offsetLeft - this.items[0].offsetLeft;
  };

  Sightings.prototype.nearest = function () {
    var left = Math.abs(this.track.scrollLeft);
    var best = Infinity;
    var index = 0;
    for (var i = 0; i < this.count; i++) {
      var dist = Math.abs(this.offsetOf(i) - left);
      if (dist < best) {
        best = dist;
        index = i;
      }
    }
    return index;
  };

  Sightings.prototype.scrollToCard = function (i) {
    var left = Math.min(this.offsetOf(i), this.scrollMax());
    var behavior = reduceMotion() ? 'auto' : 'smooth';
    try {
      this.track.scrollTo({ left: left, behavior: behavior });
    } catch (e) {
      this.track.scrollLeft = left;
    }
  };

  Sightings.prototype.advance = function () {
    var max = this.scrollMax();
    var left = Math.abs(this.track.scrollLeft);
    var next = this.nearest() + 1;
    if (left >= max - 4 || next >= this.count) next = 0;
    this.scrollToCard(next);
  };

  Sightings.prototype.progress = function () {
    if (this.desktop) return;
    var max = this.scrollMax();
    var value = max > 0 ? Math.min(Math.abs(this.track.scrollLeft) / max, 1) : 0;
    this.root.style.setProperty('--noir-sightings-progress', value.toFixed(4));
  };

  /* ---------- Theme editor ---------- */
  Sightings.prototype.show = function (item) {
    var i = this.items.indexOf(item);
    if (i < 0) return;
    this.stop();
    if (this.desktop) {
      if (this.viewport) this.viewport.scrollLeft = 0;
      this.index = Math.min(i, this.maxIndex());
      this.render();
    } else {
      this.scrollToCard(i);
    }
  };

  Sightings.prototype.destroy = function () {
    this.pause();
    if (this.frame) window.cancelAnimationFrame(this.frame);
    if (this.track) {
      this.root.removeEventListener('click', this.onClick);
      if (this.controls) this.controls.removeEventListener('focusin', this.onFocusIn);
      this.track.removeEventListener('touchstart', this.onInput);
      this.track.removeEventListener('pointerdown', this.onInput);
      this.track.removeEventListener('wheel', this.onInput);
      this.track.removeEventListener('keydown', this.onInput);
      this.track.removeEventListener('scroll', this.onScroll);
    }
    document.removeEventListener('visibilitychange', this.onVisibility);
    listen(motionQuery, this.onMotion, false);
    listen(desktopQuery, this.onMode, false);
    if (!desktopQuery) window.removeEventListener('resize', this.onMode);
    if (this.resizer) this.resizer.disconnect();
    if (this.observer) this.observer.disconnect();
    if (this.loader) this.loader.disconnect();
    this.root.__noirSightings = null;
  };

  function roots(scope) {
    var base = scope || document;
    var list = [];
    if (base.matches && base.matches(ROOT)) list.push(base);
    return list.concat(toArray(base.querySelectorAll ? base.querySelectorAll(ROOT) : []));
  }

  function init(scope) {
    roots(scope).forEach(function (el) {
      if (!el.__noirSightings) el.__noirSightings = new Sightings(el);
    });
  }

  function destroy(scope) {
    roots(scope).forEach(function (el) {
      if (el.__noirSightings) el.__noirSightings.destroy();
    });
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    destroy(e.target);
  });

  document.addEventListener('shopify:block:select', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;
    var item = target.closest('[data-noir-sightings-item]');
    var root = item && item.closest(ROOT);
    var instance = root && root.__noirSightings;
    if (instance) instance.show(item);
  });

  window.Noir.sightings = { init: init, destroy: destroy };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
})();
